<template>
  <v-form v-model="isNumberValid">
    <v-text-field
      ref="field"
      v-model="number"
      type="number"
      class="stock-stepper"
      append-outer-icon="mdi-plus-circle-outline"
      @click:append-outer="increment"
      prepend-icon="mdi-minus-circle-outline"
      @click:prepend="decrement"
      :rules="rules"
      hide-spin-buttons
      v-on="$listeners"
      v-bind="{ ...$attrs, ...$props }"
    />
  </v-form>
</template>

<script>
export default {
  name: 'AdminInputStockStepper',
  props: {
    value: {
      type: [Number, String],
      default: 0,
    },
    min: {
      type: [String, Number],
      default: null,
    },
    max: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      number: 0,
      isNumberValid: false,
      original: this.value,
    }
  },
  created() {
    this.number = this.value
  },
  computed: {
    numberAsInt() {
      return parseInt(this.number, 10)
    }, // numberAsInt
    rules() {
      let rules = []
      if (this.min) {
        rules.push(
          (v) =>
            Number(v) >= Number(this.min) ||
            `Enter a number greater than ${this.min}`
        )
      }
      if (this.max) {
        rules.push(
          (v) =>
            Number(v) <= Number(this.max) ||
            `Enter a number less than ${this.max}`
        )
      }
      return rules
    },
    delta() {
      return this.numberAsInt - this.original
    },
  },
  methods: {
    increment() {
      this.$refs.field.focus()
      this.number = this.numberAsInt + 1
    },
    decrement() {
      this.$refs.field.focus()
      this.number = this.numberAsInt > 0 ? this.numberAsInt - 1 : 0
    },
  },
  watch: {
    number(number) {
      if (this.max && number > Number(this.max)) {
        this.number = Number(this.max)
        return
      }
      if (this.min && number < Number(this.min)) {
        this.number = Number(this.min)
        return
      }
      this.$emit('update', +number)
    },
    delta(delta) {
      this.$emit('update:delta', delta)
    },
  },
}
</script>

<style scoped>
.stock-stepper {
  width: 100%;
  max-width: 150px;
  min-width: 50px;
}
</style>
